storefrontApp.controller("quickViewController", [
    "$scope",
    "commonService",
    "$rootScope",
    "urlService",
    "$filter",
    "$sce",
    "productService",
    "configs",
    "elasticService",
    "$window",
    function (
        $scope,
        commonService,
        $rootscope,
        urlService,
        $filter,
        $sanitize,
        productService,
        configs,
        elasticService,
        $window
    ) {
        $scope.selectedVariantId = "1";
        $scope.selectedsize = "1";
        $scope.hasStock = true;
        $scope.isInCart = false;

        $scope.threadConverterSequence = [];
        $scope.threadsPool = [];
        $scope.stabilizerList = [];
        $scope.colors = [];
        $scope.samples = null;
        $scope.threadUsedProductDetails = [];
        $scope.threadMfg = null;
        $scope.threadType = null;
        $scope.yards = "";
        $scope.gotThreads = false;

        $scope.showQuickView = function ($event, productInfo) {
            $event.preventDefault();
            if (productInfo._source.listPrice > 0) {
                urlService.trackCustomerViewProduct(productInfo._id);
            }
            if (typeof gtag !== "undefined" && gtag !== null) {
                gtag("event", "quick_view", {
                    product_id: productInfo._id,
                });
            }
            $rootscope.quickviewdata = productInfo;
            commonService.updateRecentlyViewed(productInfo._id);
            $rootscope.$emit("RefreshCurrencyConversion");
        };
        $scope.goToPatchPage = function (url) {
            $window.location.href = url;
        };
        $scope.initialize = function () {
            $rootscope.appModalOpen = true;
            getCurrentProductInfo();
            if (window && window.__env) {
                $scope.showQuickViewFreebies =
                    window.__env.showQuickViewFreebies;
            }
        };
        function getCurrentProductInfo(variantId) {
            $scope.gotThreads = false;
            $scope.productdata = $rootscope.quickviewdata;
            $scope.productdata.buyAllSizes = false;
            if (!angular.isUndefined($scope.productdata._source.variants)) {
                $scope.productVariants = $filter("orderBy")(
                    $scope.productdata._source.variants,
                    "variantId"
                );
                if (
                    angular.isUndefined(variantId) ||
                    variantId == "" ||
                    +variantId == 0
                ) {
                    $scope.activeProductVariant = $scope.productVariants[0];
                } else {
                    if (variantId > $scope.productVariants.length) {
                        $scope.activeProductVariant = $scope.productVariants[0];
                    } else {
                        $scope.activeProductVariant =
                            $scope.productVariants.filter(function (m) {
                                return m.variantId == +variantId;
                            })[0];
                    }
                }
            }
            if (
                angular.isDefined($scope.productdata._source.productType) &&
                $scope.productdata._source.productType.toLowerCase() ==
                    "physical"
            ) {
                var baseLineQty = window.__env.cartbaseLineQty || 10;
                commonService
                    .hasInventory($scope.productdata._source.itemId)
                    .then(function (response) {
                        $scope.hasStock = response.data > 0;
                        $scope.qtyInHand = response.data;
                        $scope.showQty =
                            response.data < baseLineQty && response.data > 0;
                    });
            }
            if (
                angular.isDefined($scope.productVariants) &&
                $scope.productVariants.length > 1
            ) {
                setComboSaleProperties();
            }

            if ($scope.checkIfNeedsThreads()) {
                $scope.getThreadMfgByCatalog();
            }
            $scope.getTopProducts();
        }
        $scope.updateVariant = function (selectedVariantId) {
            var selectedVariant = $scope.productdata._source.variants.filter(
                function (m) {
                    return m.variantId == +selectedVariantId;
                }
            );
            if (!angular.isUndefined(selectedVariant)) {
                $scope.activeProductVariant = selectedVariant[0];
            }
        };
        $scope.closeQuickView = function (data) {
            $rootscope.appModalOpen = false;
            $rootscope.quickviewdata = {};
        };
        $scope.getImageUrl = function (definitionName, vendor, prdId) {
            vendor = vendor.replace(/ /g, "_");
            return urlService.getImageUrl(
                definitionName,
                "xlarge",
                vendor,
                "",
                "",
                prdId.split(/-(.+)/)[1]
            );
        };
        $scope.getStabilizerImageUrl = function (
            definitionName,
            vendor,
            prdId
        ) {
            vendor = vendor.replace(/ /g, "_");
            return urlService.getImageUrl(
                definitionName,
                "medium",
                vendor,
                "",
                "",
                prdId.split(/-(.+)/)[1]
            );
        };

        $scope.getProductUrl = function (definitionName, vendor, name, id) {
            return urlService.getProductUrl(definitionName, vendor, name, id);
        };
        $scope.trustAsHtml = function (html) {
            return $sanitize.trustAsHtml(html);
        };

        $scope.isItemInCart = function (prodId, variantId) {
            var itemInCart = false;
            var itemId = prodId + (variantId != "1" ? "_var_" + variantId : "");
            if (
                $rootscope.customerCartRS != null &&
                $rootscope.customerCartRS.length > 0
            ) {
                if ($rootscope.customerCartRS.indexOf(itemId) != -1) {
                    itemInCart = true;
                }
            }

            return itemInCart;
        };

        $scope.getTopProducts = function () {
            if ($scope.stabilizerList.length == 0) {
                var topProducts = {};
                topProducts.definitionName = "Supplies";
                topProducts.keyword = "stabilizer";

                commonService
                    .getTop5Products(topProducts)
                    .then(function (data) {
                        $scope.stabilizerList = data.data;
                    });
            }
        };

        $scope.getThreadMfgByCatalog = function () {
            $scope.threadConverterSequence = [];
            $scope.threadsPool = [];
            $scope.stabilizerList = [];
            $scope.colors = [];
            $scope.samples = null;
            $scope.threadUsedProductDetails = [];
            $scope.threadMfg = null;
            $scope.threadType = null;

            if ($scope.colors.length < 1) {
                var colorSequence = $scope.productdata._source.colorSequence;
                productService
                    .getThreadMfgByCatalog($scope.productdata._source.catalog)
                    .then(function (response) {
                        if (response) {
                            if (response.data) {
                                $scope.threadMfg = response.data.threadMfg;
                                $scope.threadType = response.data.threadType;
                            }
                            if (
                                $scope.productdata._source.licensed &&
                                $scope.productdata._source.catalog.toLowerCase() ==
                                    "great notions"
                            ) {
                                $scope.threadMfg = "Madeira";
                            }
                            $scope.getThreadColors(colorSequence);
                        } else {
                            $scope.samples = [];
                        }
                    });
            }
        };

        $scope.getThreadColors = function (colorSequence) {
            var seqNo = "";
            var seqTitle = "";
            var colorCodeArray = [];
            var colorSequenceArray = [];
            if (colorSequence != undefined) {
                colorSequence = colorSequence.replace(/&|#/g, "");

                if (colorSequence.indexOf("~^~^") != -1) {
                    colorSequenceArray = colorSequence.split("~^~^");
                } else {
                    colorSequenceArray = colorSequence.split("~^");
                }
                angular.forEach(colorSequenceArray, function (seq) {
                    colorCodeArray.push(getColorCode(seq));
                });

                if ($scope.threadMfg != null) {
                    productService
                        .getThreadConverterColorChart(
                            colorCodeArray.toString(),
                            $scope.threadMfg,
                            "true"
                        )
                        .then(function (response) {
                            if (response && response.data) {
                                $scope.threadConverterSequence = response.data;
                                angular.forEach(
                                    colorSequenceArray,
                                    function (seq) {
                                        var hex,
                                            colorCode,
                                            colorName,
                                            itemId = "";
                                        var threadChart = [];
                                        colorCode = getColorCode(seq);
                                        threadChart =
                                            $scope.threadConverterSequence.filter(
                                                function (s) {
                                                    return (
                                                        s.colorCode == colorCode
                                                    );
                                                }
                                            );

                                        if (
                                            colorCode.trim().toLowerCase() ==
                                            "black"
                                        ) {
                                            hex = "000";
                                        } else if (
                                            colorCode.trim().toLowerCase() ==
                                            "white"
                                        ) {
                                            hex = "fff";
                                        } else if (
                                            angular.isDefined(threadChart) &&
                                            threadChart.length > 0
                                        ) {
                                            hex = threadChart[0].hex;
                                            colorName =
                                                threadChart[0].colorName;
                                            itemId = threadChart[0].itemId;
                                        }
                                        if (seq.indexOf(".") < 1) {
                                            seqNo = "";
                                            seqTitle = seq;
                                        } else {
                                            seqNo = seq.split(".")[0];
                                            seqTitle = seq.substring(
                                                seq.indexOf(".") + 1
                                            );
                                        }
                                        var threadUrl =
                                            urlService.getProductUrl(
                                                "Threads",
                                                $scope.threadMfg,
                                                $scope.threadMfg +
                                                    " " +
                                                    $scope.threadType +
                                                    " " +
                                                    colorName,
                                                itemId
                                            );

                                        $scope.colors.push({
                                            seqNo: seqNo,
                                            title: seqTitle,
                                            threadUrl: threadUrl,
                                            bgCode:
                                                angular.isDefined(hex) &&
                                                hex !== ""
                                                    ? "#" + hex
                                                    : "",
                                        });
                                    }
                                );

                                angular.forEach(
                                    $scope.threadConverterSequence,
                                    function (value, key) {
                                        var exists = false;
                                        angular.forEach(
                                            $scope.threadsPool,
                                            function (val2, key) {
                                                if (
                                                    angular.equals(
                                                        value.threadLength,
                                                        val2.threadLength
                                                    )
                                                ) {
                                                    exists = true;
                                                }
                                            }
                                        );
                                        if (
                                            exists == false &&
                                            value.threadLength != ""
                                        ) {
                                            $scope.threadsPool.push({
                                                threadLength:
                                                    value.threadLength,
                                                threadMfg: value.threadMfg,
                                            });
                                        }
                                    }
                                );
                                if ($scope.threadsPool.length > 0) {
                                    getThreadsYard();
                                } else {
                                    $scope.samples = [];
                                }
                            } else {
                                $scope.samples = [];
                            }
                        });
                } else {
                    angular.forEach(colorSequenceArray, function (title) {
                        if (title.indexOf(".") < 0) {
                            seqNo = "";
                            seqTitle = title;
                        } else {
                            seqNo = title.substr(0, title.indexOf(".")).trim();
                            seqTitle = title
                                .substr(title.indexOf(".") + 1)
                                .trim();
                        }
                        $scope.colors.push({
                            seqNo: seqNo,
                            bgCode: "",
                            threadUrl: "",
                            title: seqTitle,
                        });
                    });

                    $scope.samples = [];
                }
            } else {
                $scope.samples = [];
            }
        };

        function getColorCode(sequence) {
            if (sequence.indexOf("(") !== -1 && sequence.indexOf(")") !== -1) {
                return sequence.substring(
                    sequence.indexOf("(") + 1,
                    sequence.indexOf(")")
                );
            } else {
                return sequence.substring(sequence.indexOf(".") + 1).trim();
            }
        }

        function getThreadsYard() {
            $scope.yards = $scope.threadsPool[0].threadLength;
            $scope.threadsUsed = $scope.threadConverterSequence.filter(
                function (s) {
                    return s.threadLength == $scope.yards;
                }
            );
            $scope.getThreadProductInfo();
        }

        $scope.getThreadProductInfo = function () {
            var elmId = 0;
            if ($scope.threadsUsed[0].itemId.indexOf("_var_") > 1) {
                elmId = $scope.threadsUsed[0].itemId.split("_var_")[0];
            } else {
                elmId = $scope.threadsUsed[0].itemId;
            }

            commonService
                .getElasticData(
                    configs.elasticBaseUrl,
                    elasticService.buildProductInfoRequest(elmId.toLowerCase())
                )
                .then(function (response) {
                    if (response) {
                        if (response.data.hits.hits.length > 0) {
                            angular.forEach(
                                $scope.threadsUsed,
                                function (item) {
                                    var elmVar = 1;
                                    if (item.itemId.indexOf("_var_") > 1) {
                                        elmVar = item.itemId.split("_var_")[1];
                                    } else {
                                        elmVar = 1;
                                    }
                                    var filteredvariants =
                                        response.data.hits.hits[0]._source.variants.filter(
                                            function (res) {
                                                return res.variantId == elmVar;
                                            }
                                        );
                                    var name,
                                        salePrice,
                                        clubPrice,
                                        listPrice,
                                        threadType,
                                        threadMfg,
                                        catalogName,
                                        colorName,
                                        colorCode,
                                        itemId,
                                        variantLabel,
                                        hex,
                                        variantId,
                                        definitionName,
                                        threadConeImageName = "";
                                    if (filteredvariants.length > 0) {
                                        salePrice =
                                            filteredvariants[0].salePrice;
                                        clubPrice =
                                            filteredvariants[0].clubPrice;
                                        listPrice =
                                            filteredvariants[0].listPrice;
                                    }
                                    colorCode = item.colorCode;
                                    colorName = item.colorName;
                                    itemId = item.itemId.toLowerCase();
                                    hex = "#" + item.hex;
                                    threadMfg = item.threadMfg;
                                    threadType = item.threadType.split(" ")[0];
                                    name =
                                        response.data.hits.hits[0]._source.name;
                                    definitionName =
                                        response.data.hits.hits[0]._source
                                            .definitionName;
                                    threadConeImageName =
                                        item.threadConeImageName;
                                    catalogName = item.catalogName;
                                    $scope.threadUsedProductDetails.push({
                                        salePrice: salePrice,
                                        clubPrice: clubPrice,
                                        listPrice: listPrice,
                                        colorCode: colorCode,
                                        itemId: itemId,
                                        colorName: colorName,
                                        hex: hex,
                                        threadMfg: threadMfg,
                                        threadType: threadType,
                                        definitionName: definitionName,
                                        threadConeImageName:
                                            threadConeImageName,
                                        catalogName: catalogName,
                                    });
                                }
                            );

                            $scope.samples = angular.copy(
                                $scope.threadUsedProductDetails.slice(
                                    0,
                                    $scope.getActiveCarousalLength()
                                )
                            );
                            $scope.activeIndex =
                                $scope.getActiveCarousalLength() - 1;
                            $scope.getActiveSamples();
                        } else {
                            $scope.samples = [];
                        }
                    } else {
                        $scope.samples = [];
                    }
                });
        };

        $scope.getActiveSamples = function () {
            if ($scope.getActiveCarousalLength() != $scope.samples.length) {
                $scope.activeIndex = $scope.getActiveCarousalLength() - 1;
                $scope.samples = $scope.threadUsedProductDetails.slice(
                    0,
                    $scope.getActiveCarousalLength()
                );
                // $scope.$apply();
                $rootscope.$emit("RefreshCurrencyConversion");
            }
        };

        $scope.getActiveCarousalLength = function () {
            if ($scope.windowWidth > 1200) {
                return 6;
            } else if ($scope.windowWidth > 992 && $scope.windowWidth < 1199) {
                return 4;
            } else if ($scope.windowWidth > 450 && $scope.windowWidth < 990) {
                return 3;
            } else if ($scope.windowWidth < 450) {
                return 2;
            } else {
                return 3;
            }
        };

        $scope.getThreadsUsed = function (yards) {
            $scope.threadsUsed.length = 0;
            $scope.threadsUsed = [];
            $scope.threadUsedProductDetails = [];
            $scope.samples = null;
            threadsUsedIndex = 0;

            $scope.yards = yards;

            $scope.threadsUsed = $scope.threadConverterSequence.filter(
                function (s) {
                    return s.threadLength == yards;
                }
            );

            $scope.getThreadProductInfo();
        };

        $scope.onNavClick = function (navOption) {
            switch (navOption) {
                case "prev":
                    if (
                        $scope.activeIndex -
                            $scope.getActiveCarousalLength() +
                            1 >
                        0
                    ) {
                        $scope.activeIndex = $scope.activeIndex - 1;
                        $scope.samples.pop();
                        $scope.samples.unshift(
                            $scope.threadUsedProductDetails[
                                $scope.activeIndex -
                                    $scope.getActiveCarousalLength() +
                                    1
                            ]
                        );
                    }
                    break;
                default:
                    if (
                        $scope.activeIndex <
                        $scope.threadUsedProductDetails.length - 1
                    ) {
                        $scope.activeIndex = $scope.activeIndex + 1;
                        $scope.samples.splice(0, 1);
                        $scope.samples.push(
                            $scope.threadUsedProductDetails[$scope.activeIndex]
                        );
                    }
                    break;
            }
        };

        $scope.checkIfNeedsThreads = function () {
            if ($window.location.pathname == "/cart") {
                return false;
            }

            if (
                $scope.productdata._source.definitionName.toLowerCase() ==
                    "stockdesign" ||
                $scope.productdata._source.definitionName.toLowerCase() ==
                    "printart" ||
                $scope.productdata._source.definitionName.toLowerCase() ==
                    "svg" ||
                $scope.productdata._source.definitionName.toLowerCase() ==
                    "designpack" ||
                $scope.productdata._source.definitionName.toLowerCase() ==
                    "font" ||
                $scope.productdata._source.definitionName.toLowerCase() ==
                    "fontpack" ||
                $scope.productdata._source.definitionName.toLowerCase() ==
                    "projectpack"
            ) {
                return true;
            }

            return false;
        };
        function setComboSaleProperties() {
            commonService
                .getComboSaleSettings(
                    $scope.productdata._source.itemId,
                    $scope.productdata._source.definitionName,
                    $scope.productdata._source.catalog,
                    $scope.productVariants
                )
                .then(function (response) {
                    $scope.quickviewdata.isCombosaleactive = Boolean(
                        response && response.data.isComboSaleActive
                    );
                    $scope.quickviewdata.isCombosaleapplied = Boolean(
                        response && response.data.isComboSaleApplied
                    );
                });
        }
    },
]);

storefrontApp.controller("recentlyViewedController", [
    "$scope",
    "commonService",
    function ($scope, commonService) {
        $scope.updateRecentlyViewed = function (productId) {
            commonService.updateRecentlyViewed(productId);
        };
    },
]);
